/* eslint-disable camelcase */
export const Email_Address = "EmailAddress";
export const Business_Name = "BusinessName";
export const Address1 = "Address1";
export const City = "City";
export const Postal_Code = "PostalCode";
export const State_Id = "StateId";
